import React from 'react'
import PropTypes from 'prop-types'
import {
  InstantSearch,
  connectRefinementList,
  connectToggleRefinement,
} from 'react-instantsearch-dom'
import { useBookThisWeekDirectory } from '@hooks/useCoachesBookThisWeek'
import ConfigureWithLocation from './ConfigureWithLocation'

const VirtualRefinementList = connectRefinementList(() => null)
const VirtualToggleRefinement = connectToggleRefinement(() => null)

function CoachesSearchFindResultsState(props) {
  const {
    searchClient,
    resultsState,
    onSearchStateChange,
    searchState,
    createURL,
    indexName,
    onSearchParameters,
    aroundLatLng,
    aroundRadius,
    bookThisWeekOnly,
    bookThisWeekObjectIDs,
  } = props
  const { objectIDs, ready } = useBookThisWeekDirectory({
    aroundLatLng,
    aroundRadius,
    bookThisWeekOnly,
    initialObjectIDs: bookThisWeekObjectIDs,
  })
  return (
    <InstantSearch
      searchClient={searchClient}
      resultsState={resultsState}
      onSearchStateChange={onSearchStateChange}
      searchState={searchState}
      createURL={createURL}
      indexName={indexName}
      onSearchParameters={onSearchParameters}
      {...props}
    >
      <ConfigureWithLocation {...{
        aroundLatLng,
        aroundRadius,
        bookThisWeekOnly,
        objectIDs,
        ready,
      }}
      />
      {/* when pre-populating search results using findResultsState, we need
        * to include any refiners that will be rendered in the actual layout,
        * otherwise refinement options coming from the query string are ignored
        * - ref: https://github.com/algolia/react-instantsearch/issues/1982#issuecomment-460295364
        */}
      <VirtualRefinementList attribute="serviceTypes.services.serviceName" operator="or" limit={50} />
      <VirtualRefinementList attribute="experienceTypes.experiences.experienceName" operator="or" limit={50} />
      <VirtualRefinementList attribute="gender" operator="and" limit={50} />
      <VirtualRefinementList attribute="memberType" operator="or" limit={50} />
      <VirtualToggleRefinement attribute="bookable" value />
    </InstantSearch>
  )
}

CoachesSearchFindResultsState.propTypes = {
  searchClient: PropTypes.object,
  resultsState: PropTypes.object,
  onSearchStateChange: PropTypes.func,
  searchState: PropTypes.object,
  createURL: PropTypes.any,
  indexName: PropTypes.string,
  onSearchParameters: PropTypes.func,
  aroundLatLng: PropTypes.string,
  aroundRadius: PropTypes.number,
  bookThisWeekOnly: PropTypes.bool,
  bookThisWeekObjectIDs: PropTypes.arrayOf(PropTypes.string),
  refinerData: PropTypes.shape({
    Services: PropTypes.shape({
      serviceTypes: PropTypes.arrayOf(PropTypes.shape({
        typeName: PropTypes.string,
        services: PropTypes.arrayOf(PropTypes.shape({
          serviceName: PropTypes.string,
        })),
      })),
    }),
    Experiences: PropTypes.shape({
      experienceTypes: PropTypes.arrayOf(PropTypes.shape({
        typeName: PropTypes.string,
        experiences: PropTypes.arrayOf(PropTypes.shape({
          experienceName: PropTypes.string,
        })),
      })),
    }),
  }),
}

export default CoachesSearchFindResultsState
